class CartItem {
	constructor(model = {}) {
		this.productId = model.productId;
		this.variantId = model.variantId;
		this.sellingPlanId = model.sellingPlanId;
		this.quantity = model.quantity ? parseInt(model.quantity) : 1;
		this.pricePerUnit = model.pricePerUnit ? parseFloat(model.pricePerUnit) : 0;
		this.img = model.img;
		this.productTitle = model.productTitle ? model.productTitle : 'Product Name';
		this.sellingPlanTitle = model.sellingPlanTitle ? model.sellingPlanTitle : '';

		this.variantTitle = model.variantTitle ? model.variantTitle : '';
		this.currencyCode = model.currencyCode || '';
	}

	get totalPrice() {
		return parseInt(this.quantity) * parseFloat(this.pricePerUnit);
	}

	increaseQuantity(amount = 1) {
		this.quantity += amount;
	}

	decreaseQuantity(amount = 1) {
		this.quantity -= amount;
	}

	fillFromRecoveredProduct(
		recoveredProduct,
		variantId,
		sellingPlanId,
		quantity,
		{ isUS_CA = false } = {},
	) {
		// console.log('fillFromRecoveredProduct', recoveredProduct, variantId, sellingPlanId, quantity)
		let variants = recoveredProduct.variants || [];
		let sellingPlans = sellingPlanId ? recoveredProduct.sellingPlanGroups[0].sellingPlans : [];
		let selectedVariant = variants.find((m) => {
			return m.id == variantId;
		});

		const fallbackVariantIndex = isUS_CA ? 1 : 0;
		const fallbackVariant = variants[fallbackVariantIndex] || variants[0];
		const variantForPrice = selectedVariant || fallbackVariant;
		const priceAmount = variantForPrice?.priceV2?.amount ?? 0;
		let price = parseFloat(priceAmount);

		let sellingPlanTitle = null;
		if (sellingPlanId) {
			let sellingPlan = sellingPlans.find((m) => {
				return m.id == sellingPlanId;
			});
			sellingPlanTitle = sellingPlan.name;
		}

		let variantTitle = '';
		if (variantId) {
			let variant = variants.find((m) => {
				return m.id == variantId;
			});

			variantTitle = variant?.title || '';

			if (variantTitle === 'Default Title') {
				variantTitle = '';
			}
		}

		(this.productId = recoveredProduct.id),
			(this.variantId = variantId),
			(this.sellingPlanId = sellingPlanId),
			(this.img = recoveredProduct.img),
			(this.pricePerUnit = price),
			(this.quantity = quantity ? quantity : 1),
			(this.productTitle = recoveredProduct.title),
			(this.sellingPlanTitle = sellingPlanTitle),
			(this.variantTitle = variantTitle),
			(this.currencyCode = variantForPrice?.priceV2?.currencyCode || '');
	}
}
